<template>
  <div id="app" @dragenter="dragEnter">
    <div class="demo-layout mdl-layout mdl-layout--fixed-drawer mdl-layout--fixed-header">
      <header class="demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600" style="display: none">
        <div class="mdl-layout__header-row">
        </div>
      </header>
      <div class="demo-drawer mdl-layout__drawer mdl-color--blue-grey-900 mdl-color-text--blue-grey-50"
           id="main-drawer"
           v-if="loggedIn"
           v-bind:class="{ 'is-visible': drawerVisible }">

        <header class="demo-drawer-header">
          <img src="/static/images/voleadstools2_mid.png" class="demo-avatar">
        </header>
        <LeftMenu></LeftMenu>

      </div>
      <main class="mdl-layout__content mdl-color--grey-100"
           v-bind:class="{ 'drawer-is-visible': drawerVisible && loggedIn }">
        <button v-if="loggedIn" tabindex="0" class="drawer-button" v-on:click="showDrawer">
          <i v-if="!drawerVisible" class="material-icons"></i>
          <i v-if="drawerVisible" class="material-icons">chevron_left</i>
        </button>
        <div>
          <router-view></router-view>
        </div>
      </main>
    </div>
    <overlay-component :overlayModel = overlayModel></overlay-component>
    <GlobalDropZone></GlobalDropZone>
  </div>
</template>

<script>

  import api from "api"
  import LoginForm from "./components/emailPassword/LoginForm.vue"
  import LeftMenu from "./components/LeftMenu.vue"
  import { OverlayComponent } from "./components/utils/overlayLayer.js"
  import overlayModel from "./components/utils/overlayModel.js"

  import { GlobalDropZone, dropZoneState } from "./components/utils/GlobalDropZone";


  let drawerFocusLostListener

  export default {
    name: 'app',
    metaInfo: {
      title: 'Semgregate',
      titleTemplate: '%s | Semgregate'
    },
    components: {
      LoginForm, LeftMenu, OverlayComponent, GlobalDropZone
    },
    data() {
      return {
        drawerVisible: false
      }
    },
    computed: {
      title() {
        var title = this.$route.name
        try {
          title = app.$route.matched[0].components.default.metaInfo.title
        } catch(e) {}
        return title
      },
      loggedIn() {
        return api.session.loggedIn
      },
      overlayModel() { return overlayModel }
    },
    methods: {
      dragEnter(ev) {
        console.log("DRAG ENTER")
        dropZoneState.visible = true
      },
      showDrawer() {
        this.drawerVisible = ! this.drawerVisible
      }
    },
    watch: {
      drawerVisible(visible) {
        /*if(drawerFocusLostListener) document.body.removeEventListener("touch", drawerFocusLostListener)
        if(drawerFocusLostListener) document.body.removeEventListener("click", drawerFocusLostListener)
        if(visible) {
          drawerFocusLostListener = (ev) => {
            let tg = ev.target
            /!*while(tg) {
              if (tg.getAttribute('id') == 'main-drawer') return;
              tg = tg.parentElement
            }*!/
            this.drawerVisible = false
          }
        }
        if(drawerFocusLostListener) document.body.addEventListener("touch", drawerFocusLostListener, true)
        if(drawerFocusLostListener) document.body.addEventListener("click", drawerFocusLostListener, true)*/
      }
    },
    created() {
      window.app = this
    },
    mounted() {
      document.querySelector("#preload").style.display = "none"
    },
    beforeDestroy() {
      if(drawerFocusLostListener) document.body.removeEventListener("touch", drawerFocusLostListener)
      if(drawerFocusLostListener) document.body.removeEventListener("click", drawerFocusLostListener)
    }
  }
</script>

<style>

  html, body {
    font-family: 'Roboto', 'Helvetica', sans-serif;
  }
  #app {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .demo-avatar {
    width: 48px;
    height: 48px;
    border-radius: 24px;
  }
  .demo-layout .mdl-layout__header .mdl-layout__drawer-button {
    color: rgba(0, 0, 0, 0.54);
  }
  .mdl-layout__drawer .avatar {
    margin-bottom: 16px;
  }
  .demo-drawer {
    border: none;
  }
  /* iOS Safari specific workaround */
  .demo-drawer .mdl-menu__container {
    z-index: -1;
  }
  .demo-drawer .demo-navigation {
    z-index: -2;
  }
  .demo-navigation a {
    cursor: pointer;
  }
  /* END iOS Safari specific workaround */
  .demo-drawer .mdl-menu .mdl-menu__item {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .demo-drawer-header {
    box-sizing: border-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    padding: 16px;
    height: 151px;
  }

  .demo-navigation {
    -webkit-flex-grow: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
  }
  .demo-layout .demo-navigation .mdl-navigation__link {
    display: -webkit-flex !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    color: rgba(255, 255, 255, 0.56);
    font-weight: 500;
  }
  .demo-layout .demo-navigation .mdl-navigation__link:hover {
    background-color: #00BCD4;
    color: #37474F;
  }
  .demo-navigation .mdl-navigation__link .material-icons {
    font-size: 24px;
    color: rgba(255, 255, 255, 0.56);
    margin-right: 32px;
  }

  .demo-cards .demo-separator {
    height: 32px;
  }
  .demo-cards .mdl-card__title.mdl-card__title {
    color: white;
    font-size: 24px;
    font-weight: 400;
  }
  .demo-cards ul {
    padding: 0;
  }
  .demo-cards h3 {
    font-size: 1em;
  }
  .demo-updates .mdl-card__title {
    min-height: 200px;
    /* background-image: url('images/dog.png'); */
    background-position: 90% 100%;
    background-repeat: no-repeat;
  }
  .demo-cards .mdl-card__actions a {
    color: #00BCD4;
    text-decoration: none;
  }

  .demo-options h3 {
    margin: 0;
  }
  .demo-options .mdl-checkbox__box-outline {
    border-color: rgba(255, 255, 255, 0.89);
  }
  .demo-options ul {
    margin: 0;
    list-style-type: none;
  }
  .demo-options li {
    margin: 4px 0;
  }
  .demo-options .material-icons {
    color: rgba(255, 255, 255, 0.89);
  }
  .demo-options .mdl-card__actions {
    height: 64px;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    box-sizing: border-box;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  @media screen and (min-width: 1025px) {
    .mdl-layout--fixed-drawer>.mdl-layout__drawer {
      -webkit-transform: translateX(-250px);
      transform: translateX(-250px);
    }
  }
  .mdl-layout--fixed-drawer>.mdl-layout__content {
    margin-left: 0px;
    transition: 0.23s margin-left;
  }
  .mdl-layout--fixed-drawer>.mdl-layout__content.drawer-is-visible {
    margin-left: 240px;
    background: red;
  }

  @media screen and (max-width: 1024px) {
    .mdl-layout__header-row {
      height: 56px;
      padding: 0 16px 0 72px;
    }
    .mdl-layout__header {
      display: block;
    }
  }

  .drawer-button {
    border: none;
    position: absolute;
    left: 11px;
    top: 6px;
    width: 1.6em;
    height: 43px;
    font-size: 26px;
    line-height: 19px;
    background: none;
  }

  #main-drawer.is-visible {
    -webkit-transform: translateX(0px);
    transform: translateX(0px);
  }

  @media screen and (min-width: 1025px) {
    .drawer-button {
      border: none;
      position: absolute;
      left: 8px;
      top: 10px;
      width: 1.6em;
      height: 44px;
      font-size: 35px;
      line-height: 19px;
      background: none;
    }
  }

  *:focus {
    outline: 0;
  }

  .overlayLayer {
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    overflow: visible;
    z-index: 10;
  }
  .overlayAnchor {
    position: absolute;
    display: flex;
    width: auto;
    height: auto;
  }

  .mdl-layout__drawer.is-visible~.mdl-layout__content.mdl-layout__content {
    overflow: auto;
  }

  .dropZone {
    z-index: 2;
    box-sizing: border-box;
    display: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(143, 143, 252, 0.7);
    border: 11px dashed #9797ff;
  }
  .dropZone.visible {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// App.vue?c3a1d4fe